export const REDESIGN_THEMED_PAGES = [
  "/cancellation/",
  "/identification-form/",
  "/newsletter/",
];
